import * as Yup from 'yup';
import { datetimeFromUTC } from 'utils/dayjs';

const dateRegexp = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;

export default Yup.object().shape( {
    customerName: Yup.string().required( 'Заполните поле' ),
    customerSurname: Yup.string().required( 'Заполните поле' ),
    customerEmail: Yup.string()
        .email('Неверный формат email')
        .required( 'Заполните поле' ),
    password: Yup.string()
        .required( 'Заполните поле' )
        .min( 8, 'Длина пароля должна быть больше 8 символов' )
        .max( 128, 'Длина пароля должна быть меньше 128 символов' ),
    passwordConfirmation: Yup.string()
        .when( "password", {
            is: val => val && val.length > 0,
            then: fieldSchema => fieldSchema
                .oneOf( [ Yup.ref( "password" ) ], "Пароли должны совпадать" )
        } )
        .required( 'Заполните поле' ),
    customerBirthday: Yup.string().nullable()
        .required( 'Заполните поле' )
        .test( 'customerBirthday', 'Неверный формат даты', function ( value ) {
            if ( !value ) return false;
            if (new Date(datetimeFromUTC(value, true).date) >= new Date()) return false;
            return dateRegexp.test(datetimeFromUTC(value, true).date)
        } ),
    acceptConditions: Yup.boolean()
        .required( 'Нужно согласие на обработку персональных данных' )
        .oneOf( [ true ], 'Нужно согласие на обработку персональных данных' )
} );
